export type TGuild = {
  id: number;
  region: string;
  realm: string;
  name: string;
  faction: string;
  streamType: string;
  streamName: string;
  isDeletable: true;
  logo?: string;
  color?: string;
};

export const WATCH_GUILDS_BY_RAID: Record<string, TGuild[]> = {
  'the-venomous-abyss': [
    {
      id: 1712677,
      region: 'us',
      realm: 'illidan',
      name: 'Liquid',
      faction: 'horde',
      streamType: 'twitch',
      streamName: 'TeamLiquid',
      isDeletable: true
    },
    {
      id: 1047044,
      region: 'eu',
      realm: 'tarren-mill',
      name: 'Echo',
      faction: 'horde',
      streamType: 'twitch',
      streamName: 'echo_esports',
      isDeletable: true
    },
    {
      id: 316123,
      region: 'eu',
      realm: 'twisting-nether',
      name: 'Method',
      faction: 'horde',
      streamType: 'twitch',
      streamName: 'method',
      isDeletable: true
    }
  ],
  // Side raid released alongside The Venomous Abyss (Midnight S2). It has no
  // RWF coverage page (supportsGlobalCoverage: false), but the same guilds raced
  // it, so it carries the same watch list — that is what lists a raid in the
  // analyzer raid picker and adds the RWF Analyzer link to its nav submenu.
  'the-tidebound-grotto': [
    {
      id: 1712677,
      region: 'us',
      realm: 'illidan',
      name: 'Liquid',
      faction: 'horde',
      streamType: 'twitch',
      streamName: 'TeamLiquid',
      isDeletable: true
    },
    {
      id: 1047044,
      region: 'eu',
      realm: 'tarren-mill',
      name: 'Echo',
      faction: 'horde',
      streamType: 'twitch',
      streamName: 'echo_esports',
      isDeletable: true
    },
    {
      id: 316123,
      region: 'eu',
      realm: 'twisting-nether',
      name: 'Method',
      faction: 'horde',
      streamType: 'twitch',
      streamName: 'method',
      isDeletable: true
    }
  ],
  sporefall: [
    {
      id: 1712677,
      region: 'us',
      realm: 'illidan',
      name: 'Liquid',
      faction: 'horde',
      streamType: 'twitch',
      streamName: 'TeamLiquid',
      isDeletable: true
    },
    {
      id: 1047044,
      region: 'eu',
      realm: 'tarren-mill',
      name: 'Echo',
      faction: 'horde',
      streamType: 'twitch',
      streamName: 'echo_esports',
      isDeletable: true
    },
    {
      id: 316123,
      region: 'eu',
      realm: 'twisting-nether',
      name: 'Method',
      faction: 'horde',
      streamType: 'twitch',
      streamName: 'method',
      isDeletable: true
    }
  ],
  'tier-mn-1': [
    {
      id: 1712677,
      region: 'us',
      realm: 'illidan',
      name: 'Liquid',
      faction: 'horde',
      streamType: 'twitch',
      streamName: 'TeamLiquid',
      isDeletable: true
    },
    {
      id: 1047044,
      region: 'eu',
      realm: 'tarren-mill',
      name: 'Echo',
      faction: 'horde',
      streamType: 'twitch',
      streamName: 'echo_esports',
      isDeletable: true
    },
    {
      id: 316123,
      region: 'eu',
      realm: 'twisting-nether',
      name: 'Method',
      faction: 'horde',
      streamType: 'twitch',
      streamName: 'method',
      isDeletable: true
    }
  ],
  'manaforge-omega': [
    {
      id: 1712677,
      region: 'us',
      realm: 'illidan',
      name: 'Liquid',
      faction: 'horde',
      streamType: 'twitch',
      streamName: 'TeamLiquid',
      isDeletable: true
    },
    {
      id: 1047044,
      region: 'eu',
      realm: 'tarren-mill',
      name: 'Echo',
      faction: 'horde',
      streamType: 'twitch',
      streamName: 'echo_esports',
      isDeletable: true
    },
    {
      id: 316123,
      region: 'eu',
      realm: 'twisting-nether',
      name: 'Method',
      faction: 'horde',
      streamType: 'twitch',
      streamName: 'method',
      isDeletable: true
    }
  ],
  'liberation-of-undermine': [
    {
      id: 1712677,
      region: 'us',
      realm: 'illidan',
      name: 'Liquid',
      faction: 'horde',
      streamType: 'twitch',
      streamName: 'TeamLiquid',
      isDeletable: true
    },
    {
      id: 1047044,
      region: 'eu',
      realm: 'tarren-mill',
      name: 'Echo',
      faction: 'horde',
      streamType: 'twitch',
      streamName: 'echo_esports',
      isDeletable: true
    },
    {
      id: 316123,
      region: 'eu',
      realm: 'twisting-nether',
      name: 'Method',
      faction: 'horde',
      streamType: 'twitch',
      streamName: 'method',
      isDeletable: true
    }
  ],
  'nerubar-palace': [
    {
      id: 1712677,
      region: 'us',
      realm: 'illidan',
      name: 'Liquid',
      faction: 'horde',
      streamType: 'twitch',
      streamName: 'TeamLiquid',
      isDeletable: true
    },
    {
      id: 1047044,
      region: 'eu',
      realm: 'tarren-mill',
      name: 'Echo',
      faction: 'horde',
      streamType: 'twitch',
      streamName: 'echo_esports',
      isDeletable: true
    },
    {
      id: 316123,
      region: 'eu',
      realm: 'twisting-nether',
      name: 'Method',
      faction: 'horde',
      streamType: 'twitch',
      streamName: 'method',
      isDeletable: true
    }
  ],
  'amirdrassil-the-dreams-hope': [
    {
      id: 1712677,
      region: 'us',
      realm: 'illidan',
      name: 'Liquid',
      faction: 'horde',
      streamType: 'twitch',
      streamName: 'TeamLiquid',
      isDeletable: true
    },
    {
      id: 1047044,
      region: 'eu',
      realm: 'tarren-mill',
      name: 'Echo',
      faction: 'horde',
      streamType: 'twitch',
      streamName: 'echo_esports',
      isDeletable: true
    },
    {
      id: 316123,
      region: 'eu',
      realm: 'twisting-nether',
      name: 'Method',
      faction: 'horde',
      streamType: 'twitch',
      streamName: 'method',
      isDeletable: true
    }
  ],
  'aberrus-the-shadowed-crucible': [
    {
      id: 1047044,
      region: 'eu',
      realm: 'tarren-mill',
      name: 'Echo',
      faction: 'horde',
      streamType: 'twitch',
      streamName: 'echo_esports',
      isDeletable: true
    },
    {
      id: 1712677,
      region: 'us',
      realm: 'illidan',
      name: 'Liquid',
      faction: 'horde',
      streamType: 'twitch',
      streamName: 'TeamLiquid',
      isDeletable: true
    },
    {
      id: 316123,
      region: 'eu',
      realm: 'twisting-nether',
      name: 'Method',
      faction: 'horde',
      streamType: 'twitch',
      streamName: 'method',
      isDeletable: true
    }
  ],
  'vault-of-the-incarnates': [
    {
      id: 1047044,
      region: 'eu',
      realm: 'tarren-mill',
      name: 'Echo',
      faction: 'horde',
      streamType: 'twitch',
      streamName: 'echo_esports',
      isDeletable: true
    },
    {
      id: 1712677,
      region: 'us',
      realm: 'illidan',
      name: 'Liquid',
      faction: 'horde',
      streamType: 'twitch',
      streamName: 'TeamLiquid',
      isDeletable: true
    },
    {
      id: 316123,
      region: 'eu',
      realm: 'twisting-nether',
      name: 'Method',
      faction: 'horde',
      streamType: 'twitch',
      streamName: 'method',
      isDeletable: true
    }
  ]
};
